import { selectOfferChatId } from './selectOfferChatId';
import { IState } from '../../store';

export const selectIsOfferChatExists = (state: IState): boolean => {
  const chatId = selectOfferChatId(state);

  return !!chatId;
};
